export default __webpack_public_path__ + "static/media/Shivanand_N_Neela.4119fe3f.jpg";